import Placeholder from '@tiptap/extension-placeholder';
import { EditorContent, useEditor } from '@tiptap/react';
import { useTranslation } from 'react-i18next';

import React from 'react';

import { createBaseEditorExtensions } from './editor/core/editorExtensions.js';

/**
 * @param {import('./noneditableEditor').NonEditableEditorProps} props
 * @returns {JSX.Element}
 */
function NonEditableEditor(props) {
  const { t } = useTranslation();

  const editor = useEditor(
    {
      content: props.content ? `${props.content}` : null,
      editable: false,
      editorProps: {
        attributes: {
          class:
            'prose prose-sm sm:prose lg:prose-lg xl:prose-2xl mx-auto max-w-full focus:outline-none p-4 bg-white text-slate-900 dark:bg-slate-900 dark:text-slate-100 dark:prose-invert',
        },
      },
      extensions: [
        ...createBaseEditorExtensions({ openLinkOnClick: true }),
        Placeholder.configure({
          placeholder:
            props.placeholder !== undefined
              ? props.placeholder
              : t('oneOnOne.meeting.content.placeholder'),
        }),
      ],
      onUpdate: ({ editor: activeEditor }) => {
        props.setContent(activeEditor.getHTML());
      },
    },
    [props.content]
  );

  return (
    <React.Fragment>
      <EditorContent
        className={`w-full rounded-lg bg-white text-left dark:bg-slate-900 dark:text-slate-100 ${props.className || ''}`.trim()}
        editor={editor}
        id="editor"
      />
    </React.Fragment>
  );
}

export default NonEditableEditor;
